import type { RouteObject } from 'react-router-dom';

/**
 * Views 4 (account) and 5 (API keys), plus the organisation's user
 * administration. Inside the shell, but with no destination in the sidebar
 * menu: they are reached from view 4 (§4.12).
 */
export const accountRoutes: RouteObject[] = [
  {
    path: 'account',
    lazy: () =>
      import('@/routes/pages/AccountPage').then((m) => ({
        Component: m.AccountPage,
      })),
  },
  {
    path: 'account/api-keys',
    lazy: () =>
      import('@/routes/pages/ApiKeysPage').then((m) => ({
        Component: m.ApiKeysPage,
      })),
  },
  {
    path: 'account/users',
    lazy: () =>
      import('@/routes/pages/MembersPage').then((m) => ({
        Component: m.MembersPage,
      })),
  },
];
